/* Copyright (c) 2026 GM Global Technology Operations LLC. All rights reserved.
   This information is confidential and proprietary to GM Global Technology
   Operations LLC and may not be used, modified, copied or distributed. */
import gpscAuraLogo from "../../assets/gpsc-aura-logo.png";
import styles from "./GpscAuraLogo.module.css";
import {CHATBOT_WEBSITE_NAME} from "../../constants";

type GpscAuraLogoProps = {
    variant?: "default" | "large";
    className?: string;
};

export default function GpscAuraLogo({ variant = "default", className }: GpscAuraLogoProps) {
    const variantClass = variant === "large" ? styles.large : styles.default;
    const classes = [styles.logo, variantClass, className].filter(Boolean).join(" ");

    return <img src={gpscAuraLogo} alt={CHATBOT_WEBSITE_NAME} className={classes} />;
}
